import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTextStyleBold = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    aria-label="IconTextStyleBold"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M8.808 5.829a3.15 3.15 0 0 0 1.512-2.401A3.35 3.35 0 0 0 8.858.598 3.4 3.4 0 0 0 6.985 0H1.378v12h6.05a3.23 3.23 0 0 0 2.964-2.01c.158-.39.237-.809.232-1.23v-.106a3.14 3.14 0 0 0-1.82-2.825m-5.7-4.115h3.628A1.8 1.8 0 0 1 8.46 2.828a1.78 1.78 0 0 1-.126 1.36 1.8 1.8 0 0 1-1.062.878q-.266.077-.544.077h-3.62zm3.975 8.572H3.108V6.857h3.974c.368-.011.73.09 1.04.289a1.715 1.715 0 0 1-.496 3.063q-.267.077-.544.077" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTextStyleBold);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
